import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Route, RouteProps, useHistory} from "react-router";
import {addAlert, AlertType} from "@web2/ap-alerts";
import {appendQueryString, parseSearch} from "@web2/ap-request";
import {apAppLink} from "@web2/ap-routes";

import {fetchUserInfo} from "../../login/actions/get_user_info";
import {IAPStore} from "../reducers/ap_reducer";

const error401Message =
    "Brak autoryzacji: wykonanie tej czynności wymaga zalogowania do systemu, proszę zalogować się ponownie. W przypadku dalszych problemów proszę skontaktować się z administratorem aplikacji.";

export const AuthenticatedRoute: React.FC<RouteProps> = (props) => {
    const isAuthenticated = useSelector((store: IAPStore) => store.account.isAuthenticated);
    const dispatch = useDispatch();
    const history = useHistory();
    const query = {
        ...parseSearch(location.search),
        next: location.pathname
    };
    const redirectUrl = appendQueryString(apAppLink.login(), query);

    useEffect(() => {
        dispatch(fetchUserInfo());
    }, []);

    if (!isAuthenticated) {
        dispatch(addAlert({type: AlertType.ERROR, text: error401Message}, 10000));
        history.push(redirectUrl);
        return null;
    }

    return <Route {...props} />;
};
